module.exports = __webpack_public_path__ + "img/partner12.bd70cf7e.png";